export class JobStatusViewModel {
    id: number;
    name: string;
    isStored: boolean;
    isCompleted: boolean;
}